import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpHeaders } from '@angular/common/http/src/headers';
import { environment } from '../../environments/environment';
import { CreateLogin } from '../models/create-login';
import { LoginReq } from '../models/user';
import { PaymentPost } from '../models/payment-post';

@Injectable()
export class PaymentService {

  private _paymentUrl: string = `${environment.apiRootURL}/payment`;

  constructor(private _http: Http) { }

  makePayment(payment: PaymentPost) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('HTTP POST payment/makepayment');

    return this._http.post(`${this._paymentUrl}/makePayment`, JSON.stringify(payment), options).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payment.service.ts